import React, { useState, useEffect } from "react";
import { Url, DYRUrl } from "../../Services/Api";
import "./style.css";
import axios from "axios";
import BottomToust from "../../Components/BottomToust/BottomToust";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FaRegImage } from "react-icons/fa6";
import ImageGalleryPopup from "../../Components/UI-Controls/PopUp/ImageGalleryPapup/ImageGalleryPopup";
import { uploadImage } from "../../Services/functions";


export default function ResizerDYR() {

    const location = useLocation();
    const { id } = useParams();
    const { productData, viewData } = location.state || {};


    const [loading, setLoading] = useState(false);
    const [selectedSubCategories, setSelectedSubCategories] = useState([]);
    const [editId, setEditId] = useState(null);
    const [showMessage, setShowMessage] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [selectedProduct, setSelectedProduct] = useState(null)

    useEffect(() => {
        if (productData && selectedSubCategories.length > 0) {
            setEditId(productData._id);
            setSelectedProduct(productData);

            // Match all categories from product with selectedSubCategories
            const matchedCategories = selectedSubCategories.filter(subCat =>
                productData.categories?.some(prodCat => prodCat.uid === subCat.uid)
            );

            const subCategoryIds = matchedCategories.map(cat => cat._id);

            SetDataToSend({
                _id: productData._id,
                uid: productData.uid,
                name: productData.name,
                sku: productData.sku,
                slug: productData.slug,
                type: productData.type,
                parent: productData.parent,
                attributes: productData.attributes,
                regular_price: productData.regular_price,
                sale_price: productData.sale_price,
                image: productData?.image,
                png_image: productData?.png_image?._id || "",
                imageId: "",
                imageUrl: productData?.png_image?.image_url || "",
                subCategoryId: productData?.subCategoryId?._id || "",
                categoryName:  productData?.subCategoryId?.name || ""
            });
            console.log(productData,subCategoryIds, "here 2")
        }
        
    }, [productData, selectedSubCategories]);




    const fetchSelectedSubCategories = async () => {
        try {
            const response = await fetch(`${DYRUrl}/api/v1/sub-category/sub-categories`);
            const data = await response.json();
            console.log(data, "here")
            if (data && data.data) {
                setSelectedSubCategories(data.data);
            } else {
                console.error("No sub-categories found in the response data");
            }
        } catch (error) {
            console.error("Error fetching sub-categories:", error);
        }
    };


    const [selectedCategory, setSelectedCategory] = useState(null);



    useEffect(() => {
        fetchSelectedSubCategories();
    }, []);



    const handleAddOrUpdate = async () => {
        const apiCall = editId
            ? axios.put(`${DYRUrl}/api/v1/products/${editId}`, dataToSend)
            : axios.post(`${DYRUrl}/api/v1/products/add`, dataToSend);

        try {
            setLoading(true);
            await apiCall;
            setToastMessage(editId ? "Product updated successfully!" : "Product added successfully!");
            setSelectedCategory(null)
            setEditId(null);
            fetchSelectedSubCategories();
        } catch (error) {
            setToastMessage("An error occurred. Please try again.");
        } finally {
            setLoading(false);
            setShowMessage(true);
        }
        console.log(dataToSend, "here")
    };

    const [searchedProducts, setSearchedProducts] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [isSearching, setIsSearching] = useState(false);


    const searchForProducts = async (text) => {
        if (text.trim() === "") {
            setSearchedProducts([]);
            return;
        }

        const api = `/api/v1/products/by-name?per_page=100&name`;
        try {
            setIsSearching(true);
            setLoading(true);
            const response = await axios.get(`${Url + api}=${text}`);
            setSearchedProducts(response.data.products);
        } catch (error) {
            console.error("Error fetching data", error);
        } finally {
            setIsSearching(false);
            setLoading(false);
        }
    };

    const [dataToSend, SetDataToSend] = useState(
        {
            _id: "",
            uid: null,
            name: "",
            sku: "",
            slug: "",
            type: "",
            parent: 0,
            attributes: [],
            regular_price: "",
            sale_price: "",
            image: "",
            png_image: "",
            imageId: "",
            imageUrl: "",
            subCategoryId: "",
            categoryName: ""
        }
    )


    const uploadDataToSelectedProduct = (product) => {
        setSelectedProduct(product);

        // Match all categories from product with selectedSubCategories
        const matchedCategories = selectedSubCategories.filter(subCat =>
            product.categories?.some(prodCat => prodCat.uid === subCat.uid)
        );

        // Extract subCategoryIds and mainCategoryIds
        const subCategoryIds = matchedCategories.map(cat => cat._id);
        const mainCategoryIds = matchedCategories.map(cat => cat._id);

        SetDataToSend({
            _id: product._id,
            uid: product.uid,
            name: product.name,
            sku: product.sku,
            slug: product.slug,
            type: product.type,
            parent: product.parent,
            attributes: product.attributes,
            regular_price: product.regular_price,
            sale_price: product.sale_price,
            image: product?.image?.image_url,
            png_image: "",
            imageId: "",
            imageUrl: "",
            subCategoryId: subCategoryIds[0] || "",
        });
    };



    const handleImageSelect = (image) => {
        console.log(image)
        SetDataToSend((prev) => ({ ...prev, imageUrl: image.image_url, png_image: image._id }));
        handleGalleryModalClose();
    };





    const [modaldata, setModalData] = useState([]);
    const [modalView, setModalView] = useState(false);
    const handleGalleryModalOpen = () => setModalView(true);
    const handleGalleryModalClose = () => setModalView(false);
    const [imageSendPayload, setImageSendPayload] = useState({
        file: null,
        alt_text: "",
        title: "",
        description: "",
        link_url: "",
    });
    const [uploadedStatus, setUploadedStates] = useState(null);

    const getApi = async () => {
        try {
            const response = await axios.get(`${DYRUrl}/api/v1/media/get`);
            setModalData(response.data.media);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => { getApi(); }, []);


    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const api = `${DYRUrl}/api/v1/media/add`;
            const imagePayloadToSend = new FormData();
            imagePayloadToSend.append("image", file);
            imagePayloadToSend.append("alt_text", imageSendPayload.alt_text);
            imagePayloadToSend.append("title", imageSendPayload.title);
            imagePayloadToSend.append("description", imageSendPayload.description);
            imagePayloadToSend.append("image_url", imageSendPayload.image_url);
            imagePayloadToSend.append("link_url", imageSendPayload.link_url);

            await uploadImage(imagePayloadToSend, api, setUploadedStates);
            await getApi();
        }
    };


    return (
        <div className="dyr_base_comp">

            <div className="main_subcategories_dyr">
                <div className="right_side_subCat_dyr">
                    <h2>Add Product</h2>
              


                </div>
                <div className="left_side_subCat_dyr">
                    <h2></h2>
                    <div className="add_png_image" onClick={dataToSend.png_image === "" ? () => {
                        handleGalleryModalOpen()
                    } : null}>
                        {dataToSend.png_image ?
                            <img src={DYRUrl + dataToSend.imageUrl} alt="" srcset="" />
                            : <div className="api_upload_img active">
                                <FaRegImage size={30} />
                                <p>Upload PNG Image</p>
                            </div>}
                        {dataToSend.png_image && <button onClick={() => { handleGalleryModalOpen(); }} className="add_png_image_btn">
                            Change
                        </button>}
                    </div>
                </div>

            </div>
            <BottomToust
                showMessage={showMessage}
                message={toastMessage}
                handleCloseMessageModal={() => setShowMessage(false)}
            />
        </div>
    )
}